import API from './ApiBase';
import { AIJobStatusResponse } from '../types/AIJob.types';

export const getAIJobStatus = async (
  jobId: string
): Promise<AIJobStatusResponse> => {
  const response = await API.get<AIJobStatusResponse>(`/python-ai/jobs/${jobId}`);
  return response.data;
};
